import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, from, map, of } from 'rxjs';
import { IntegrationConfigurationApi } from '../services/integration.api';
import { IntegrationConfigurationStore } from './integration-configuration.facade';
import { IntegrationConfiguration } from '../interface/integration-configuration.interface';


@Injectable()
export class IntegrationConfigurationEffects {
    private actions$ = inject(Actions);
    private apiService = inject(IntegrationConfigurationApi)
    private ACTIONS = IntegrationConfigurationStore.actions;

    addAccount$ = createEffect(() =>
        this.actions$.pipe(
            ofType(this.ACTIONS.addAccount),
            exhaustMap((props) =>
                of(this.ACTIONS.loadRecordsForAccount({
                    account_id: props.accountBasedEntity.account_id,
                    accountType: props.accountBasedEntity.accountType
                }))
            )
        )
    );

    loadRecordsForAccount = createEffect(() =>
        this.actions$.pipe(
            ofType(this.ACTIONS.loadRecordsForAccount),
            exhaustMap((props) =>
                from(this.apiService.readAll()).pipe(
                    map(apiResponse => {
                        const integrations: IntegrationConfiguration[] = apiResponse && apiResponse.data ? apiResponse.data : null

                        // Check if TIME integration is ready

                        const timeConfigReady = integrations ? integrations.some(integration =>
                            integration.integrationName === 'TIME' && integration.isActive
                        ) : false;

                        return this.ACTIONS.loadAdditionalDataAccountSuccess({
                            data: {
                                integrations: integrations,
                                timeConfigReady: timeConfigReady
                            },
                            account_id: props.account_id
                        })
                    })
                )
            )
        )
    );


}
